import { render, staticRenderFns } from "./VehicleCheckHistoryCard.vue?vue&type=template&id=2adbd0c7&scoped=true&"
import script from "./VehicleCheckHistoryCard.vue?vue&type=script&lang=js&"
export * from "./VehicleCheckHistoryCard.vue?vue&type=script&lang=js&"
import style0 from "./VehicleCheckHistoryCard.vue?vue&type=style&index=0&id=2adbd0c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adbd0c7",
  null
  
)

export default component.exports